'use strict';
/*!
 * krobot-hamburger-region-selector.js
 *
 * ハンバーガーメニュー内に設置した、地域セレクトドロップダウンの Select ボタンで指定した地域URLへ遷移するボタンのJS
 *
 * @package krobot
 * @deps jquery
 */

const $ = jQuery;

$( function() {
	const $form = $( '#modal-region-selector' );
	const $select = $( '.region-select' );

	$form.on( 'submit', function( e ) {
		const selected = $select.val();
		if ( selected ) {
			window.location.href = selected;
		}
		e.preventDefault();
	} );
} );
